export const VALIDATE_PIN = 'providers/workforce/Pin/VALIDATE_PIN';
export const GENERATE_POS_PIN = 'providers/workforce/Pin/GENERATE_POS_PIN';
